import { faHouse } from '@fortawesome/pro-solid-svg-icons';
import { cn, Icon, LoadingBar } from 'corso-admin-ui';
import { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import QuickSearch from '~/components/QuickSearch';
import StoreSwitcher from '~/components/StoreSwitcher';
import { useIsConciergeWidget, useWidgetRef } from '~/hooks/widgetHooks';
import CorsoConciergeMotivator from '~/integrations/corsoConcierge/CorsoConciergeMotivator';
import { useInitialLocation } from '~/providers/InitialLocation';

function MiniMerchant({ children }: PropsWithChildren) {
  const initialLocation = useInitialLocation();
  const isCorsoConcierge = useIsConciergeWidget();

  return (
    <>
      <header
        className={cn(
          'relative rounded-b-md bg-neutral-900 p-2 text-neutral-100',
        )}
      >
        <LoadingBar className="absolute top-0 right-0 left-0" />
        <div
          className={cn(
            'flex items-center justify-between gap-2',
            isCorsoConcierge && 'justify-center',
          )}
        >
          <NavLink
            to={initialLocation} // reset to the initial navigation
            className="group flex items-center gap-2 rounded-md bg-neutral-900 p-1 focus-within:bg-neutral-800 hover:bg-neutral-800"
            hidden={isCorsoConcierge}
          >
            <div className="flex size-7 items-center justify-center rounded-lg bg-neutral-700 text-[0.625rem] font-medium text-white no-underline">
              <Icon icon={faHouse} className="size-4" />
            </div>
            <span className="sr-only">Home</span>
          </NavLink>
          <QuickSearch />
          {!isCorsoConcierge && <StoreSwitcher />}
        </div>
        <CorsoConciergeMotivator />
      </header>
      <main className="p-2 pt-3">{children}</main>
    </>
  );
}

export default function EmbeddedLayout({ children }: PropsWithChildren) {
  const widgetRef = useWidgetRef();

  if (!widgetRef) throw new Error('EmbeddedLayout used without widgetRef');
  return <MiniMerchant>{children}</MiniMerchant>; // TODO move initial whitespace for other embedded content
}
